import React from 'react'

export default function PageNotFound() {
  return (
    <div className='w-full h-full flex flex-col gap-4 items-center justify-center p-10'>
      <h1>404 | Page not found</h1>
      <h5>Oops, this is not the page you're looking for</h5>
    </div>
  )
}
